function Hero(){
  return(
    <section>
      <div className="hero">
        <div className="container">

          <div data-aos="fade-right">
            <p><span className="tag">Novo</span> Conheça nosso Programa de Pontos Átomos</p>

            <h1>Um banco transparente, completo e com a sua cara</h1>

            <p className="subtitle">Conta digital e cartão de crédito gratuitos.
            Saques e transferências sem tarifa.</p>

            <a href="#" className="btn btn-outline-white">Nossos Produtos</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero;